import BookAnimations from "./scripts/BookAnimations";
import GeneralAnimations from "./scripts/GeneralAnimations";

window.addEventListener('DOMContentLoaded', (e) => {
	if(!document.querySelector('.page-template-page-book')) return;
	new GeneralAnimations();
	new BookAnimations();
})
